export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_UNREAD_COUNT_REQUEST = 'GET_UNREAD_COUNT_REQUEST';
export const MARK_NOTIFICATION_READ_REQUEST = 'MARK_NOTIFICATION_READ_REQUEST';
export const MARK_ALL_NOTIFICATIONS_READ_REQUEST = 'MARK_ALL_NOTIFICATIONS_READ_REQUEST';
export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';
export const SEND_CUSTOM_NOTIFICATION_REQUEST = 'SEND_CUSTOM_NOTIFICATION_REQUEST';

export const getNotifications = (params = {}, callback) => ({
    type: GET_NOTIFICATIONS_REQUEST,
    payload: { params, callback }
});

export const getUnreadCount = (callback) => ({
    type: GET_UNREAD_COUNT_REQUEST,
    payload: { callback },
});

export const markNotificationRead = (id, callback) => ({
    type: MARK_NOTIFICATION_READ_REQUEST,
    payload: { id, callback }
});

export const markAllNotificationsRead = (callback) => ({
    type: MARK_ALL_NOTIFICATIONS_READ_REQUEST,
    payload: { callback }
});

export const deleteNotification = (id, callback) => ({
    type: DELETE_NOTIFICATION_REQUEST,
    payload: { id, callback }
});

export const sendCustomNotification = (recipients, subject, body, callback) => ({
    type: SEND_CUSTOM_NOTIFICATION_REQUEST,
    payload: { recipients, subject, body, callback }
});
